import { User } from '@/schema'

export const getUserInitials = (user: User): string => {
  return `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`.toUpperCase()
}

export const AVATAR_COLORS = [
  { bg: 'bg-blue-100', text: 'text-blue-700' },
  { bg: 'bg-green-100', text: 'text-green-700' },
  { bg: 'bg-purple-100', text: 'text-purple-700' },
  { bg: 'bg-orange-100', text: 'text-orange-700' },
  { bg: 'bg-pink-100', text: 'text-pink-700' },
  { bg: 'bg-indigo-100', text: 'text-indigo-700' },
  { bg: 'bg-teal-100', text: 'text-teal-700' },
  { bg: 'bg-red-100', text: 'text-red-700' },
] as const

export const getAvatarColor = (id = '') => {
  const hash = id
    .split('')
    .reduce((acc, char) => acc + (char.codePointAt(0) ?? 0), 0)
  return AVATAR_COLORS[hash % AVATAR_COLORS.length]
}
